var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-datepicker", {
                  attrs: {
                    range: true,
                    defaultStart: "-6M",
                    defaultEnd: "6M",
                    label: "평가기간",
                    name: "assessmentDates",
                  },
                  model: {
                    value: _vm.searchParam.assessmentDates,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "assessmentDates", $$v)
                    },
                    expression: "searchParam.assessmentDates",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    codeGroupCd: "RAM_ASSESS_TYPE_CD",
                    type: "search",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "ramAssessTypeCd",
                    label: "평가구분-정기/수시/최초",
                  },
                  model: {
                    value: _vm.searchParam.ramAssessTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "ramAssessTypeCd", $$v)
                    },
                    expression: "searchParam.ramAssessTypeCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    comboItems: _vm.stepItems,
                    type: "search",
                    itemText: "stepperMstNm",
                    itemValue: "stepperMstCd",
                    name: "ramStepCd",
                    label: "진행단계",
                  },
                  model: {
                    value: _vm.searchParam.ramStepCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "ramStepCd", $$v)
                    },
                    expression: "searchParam.ramStepCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "위험성평가 목록",
            tableId: "4",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
          },
          on: { linkClick: _vm.linkClick },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  _vm._v(" " + _vm._s(props.row[col.name]) + " "),
                  props.row.vendorRequestFlag === "Y"
                    ? [
                        _c("br"),
                        _c(
                          "q-badge",
                          {
                            attrs: {
                              outline: "",
                              align: "top",
                              color: "indigo-5",
                            },
                          },
                          [_vm._v(" 요청 검토중 ")]
                        ),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: { label: "등록", icon: "add_circle" },
                        on: { btnClicked: _vm.addRisk },
                      })
                    : _vm._e(),
                  _c("c-btn", {
                    attrs: { label: "검색", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }